<!-- 重仓基金列表 -->
<template>
  <div class="heavy-fund-list">
    <!-- 顶部信息 -->
    <div class="top row">
      <p class="top-tip"><span class="dot"></span>
        <span
        >重仓基金</span><span class="stock-value">{{dataSource.allHoldRatio || '--'}}</span>
      </p>
      <div class="date">{{dataSource.holdDate || '--'}}</div>
    </div>
    <!-- 持仓列表 -->
    <common-list
      :header-list="headerList"
      :data-source="getDataList()"
      :more-text="'更多持仓信息'"
      :click-track="'xpzy.pzy.gdccxx.click'">
      <template slot="list-item" slot-scope="{item}">
        <div class="row list-item" @click="$goFundApp">
          <div class="fund-name-col">
            <div>{{item.fundName}}</div>
            <div v-if="!$isEmpty(item.typeTag)" class="fund-tag">{{item.typeTag}}</div>
          </div>
          <div class="hold-ratio-col">{{item.holdRatio || '--'}}</div>
          <div class="last-col">
            <div class="previous-box row">
              <img v-if="['新增','不变'].indexOf(item.compareWithPrevious) < 0
                && !$isEmpty(item.compareWithPrevious)"
                :src="parseFloat(item.compareWithPrevious) > 0 ? UP_ARROW : DOWN_ARROW"
                class="arrow" />
              <div>{{getPreviousValue(item.compareWithPrevious)}}</div>
            </div>
            <div v-if="!$isEmpty(item.holdCount)" class="hold-count">{{item.holdCount}}</div>
          </div>
        </div>
      </template>
    </common-list>
  </div>
</template>

<script>
import CONFIG from '@/configs/default';
import CommonList from '../MarketQuotation/QuotationCommonList.vue';

export default {

  name: 'heavy-fund-list',

  components: {
    CommonList,
  },

  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      headerList: CONFIG.heavyFundListHeader || [],
      UP_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030116.png',
      DOWN_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030127.png',
    };
  },

  methods: {
    async getDataList() {
      return this.dataSource.list;
    },

    getPreviousValue(value) {
      if (['新增', '不变'].indexOf(value) >= 0) return value;
      if (this.$isEmpty(value) || this.$isEmpty(parseFloat(value))) return '--';
      try {
        return `${Math.abs(parseFloat(value)).toFixed(2)}%`;
      } catch (error) {
        return '--';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.heavy-fund-list{
  width: 100%;
  box-sizing: border-box;
  padding-right: 24px;
  margin-top: 30px;
  .top {
    justify-content: space-between;
    font-family: DINAlternate-Bold;
    color: #000000;
    .top-tip {
      font-size: 30px;
      line-height: 38px;
      height: 38px;
      margin: 0;
      .dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #f96b36;
        border-radius: 5px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .stock-value {
        font-size: 32px;
        letter-spacing: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 24px;
      }
    }
    .date {
      font-size: 28px;
      color: #999999;
      letter-spacing: 0;
      text-align: right;
      line-height: 36px;
    }
  }
  .list-item {
    justify-content: space-between;
    padding: 16px 0 24px;
    .fund-name-col {
      flex: 3;
      font-size: 30px;
      color: #000000;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .fund-tag {
        margin-top: 8px;
        background-color: rgba(102, 102, 102, 0.1);
        border-radius: 4px;
        font-size: 20px;
        color: #666666;
        padding: 4px 8px 4px 8px;
      }
    }
    .hold-ratio-col {
      flex: 2;
      font-family: DINAlternate-Bold;
      font-size: 32px;
      color: #000000;
      text-align: center;
    }
    .last-col {
      flex: 2;
      font-family: DINAlternate-Bold;
      font-size: 30px;
      color: #000000;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .previous-box {
        justify-content: flex-end;
        .arrow {
          width: 12px;
          height: 19px;
          margin-right: 8px;
        }
      }
      .hold-count {
        font-size: 20px;
        color: #666666;
        font-weight: 400;
        background: rgba(102, 102, 102,0.1);
        border-radius: 4px;
        padding: 4px 8px;
        margin-top: 12px;
      }
    }
  }
}
</style>
